import { styled } from '../theme';

const TableHeaderRow = styled('tr')(({ theme }) => ({
    height: '60px',
    background: 'transparent',
    fontFamily: theme.typography.fontFamily,
    color: theme.color.jetBlack,
    fontSize: '1.4rem',
    fontWeight: theme.typography.fontWeight.heavy,
    borderBottom: theme.border.tableRowSeparator,
    textTransform: 'uppercase',
}));

export default TableHeaderRow;
